
import React from 'react';
import MessagesBaseScreen from './MessagesBaseScreen';
import DownloadAppComponent from 'src/app/components/commonComponents/DownloadAppComponent';

const ConversationsContainer: React.FC = () => {

    return (
        <MessagesBaseScreen showFilter={false}>
            <div className='message-list-content-center d-flex align-items-center'>
                <DownloadAppComponent isLoginScreen={false} message='Conversations are only available on the eyparent app.' /> 
            </div> 
        </MessagesBaseScreen>
    )
};

export default ConversationsContainer;